export default __webpack_public_path__ + "static/media/img-3.45e02dd0.png";